import React from 'react';
import PropTypes from 'prop-types';

// TEMP: Merge into ArrowIcon
class ArrowIconLarge extends React.PureComponent {
	render() {
		const { width, height, fill } = this.props;

		const viewBox = [0, 0, width, height].join(' ');

		return (
			<svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
				<title>Arrow Icon Large</title>
				<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g
						id="header-single-page"
						transform="translate(-135.000000, -40.000000)"
						fill={fill}
						fillRule="nonzero"
					>
						<g id="header">
							<g id="main-back-icon" transform="translate(133.000000, 36.000000)">
								<path
									d="M25.6163882,13.0659448 L16.9491435,4.38386365 C16.7017309,4.13603315 16.3719776,4 16.0203708,4 C15.6683737,4 15.3388155,4.1362286 15.0914029,4.38386365 L14.3044827,5.17230865 C14.0572652,5.41974826 13.9210712,5.75025408 13.9210712,6.1026503 C13.9210712,6.45485107 14.0572652,6.79649754 14.3044827,7.04393714 L19.3608307,12.1199672 L3.29657454,12.1199672 C2.57228791,12.1199672 2,12.6879446 2,13.4136502 L2,14.5283011 C2,15.2540067 2.57228791,15.879251 3.29657454,15.879251 L19.4181961,15.879251 L14.3046778,20.9836213 C14.0574603,21.2314518 13.9212664,21.5529669 13.9212664,21.9053631 C13.9212664,22.2573685 14.0574603,22.5835744 14.3046778,22.8312094 L15.091598,23.6171136 C15.3390106,23.8649441 15.6685688,24 16.0205659,24 C16.3721727,24 16.7019261,23.8631851 16.9493386,23.6153545 L25.6165834,14.9334688 C25.8645813,14.6848565 26.0009704,14.3529826 25.9999948,14.0001954 C26.0007753,13.6462356 25.8645813,13.3141662 25.6163882,13.0659448 Z"
									transform="translate(14.000000, 14.000000) translate(-14.000000, -14.000000) "
								/>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

ArrowIconLarge.defaultProps = {
	width: 24,
	height: 20,
	fill: '#6AC8C8',
};

ArrowIconLarge.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	fill: PropTypes.string,
};

export default ArrowIconLarge;



// WEBPACK FOOTER //
// ./src/components/shared/icons/arrowIconLarge.js